<template>
  <div v-frag class="prism-elite-app">
    <CardIeaAppMain colorCard="#0F172A" title="">
      <v-col cols="12" class="pa-0 main-container-glass">
        <!-- Top Bar -->
        <div class="prism-top-bar d-flex align-center justify-space-between px-8 py-5">
           <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({ name: 'Home' })"
              class="mr-4 glass-btn"
              large
            >
              <v-icon color="primary">mdi-arrow-left-circle-outline</v-icon>
            </v-btn>
             <div>
              <h1 class="text-h6 font-weight-black prism-title mb-0">Libreta de Calificaciones</h1>
              <div class="text-caption grey--text font-weight-medium">Seguimiento de Desempeño Académico</div>
            </div>
           </div>
        </div>

        <v-divider class="prism-divider"></v-divider>

        <v-row class="pa-8">
          <v-col cols="12">
            <div class="d-flex align-center justify-space-between mb-8">
               <div>
                  <h2 class="text-h5 font-weight-black prism-heading">Resumen de Notas</h2>
                  <p class="text-caption grey--text mb-0">A continuación se detallan sus resultados por materia.</p>
               </div>
               <v-chip class="font-weight-black px-4" color="primary" outlined>
                  {{ notas.length }} MATERIAS
               </v-chip>
            </div>

            <v-row>
               <v-col v-for="(notaData, notaKey) in notas" :key="notaKey" cols="12" md="6" lg="4">
                  <v-card flat class="rounded-xl glass-card-interactive overflow-hidden h-full">
                     <div class="pa-6">
                        <div class="d-flex align-center mb-6">
                           <v-avatar size="44" color="primary lighten-5" class="mr-4 elite-avatar-glow">
                              <v-icon color="primary" size="22">mdi-book-education-outline</v-icon>
                           </v-avatar>
                           <div>
                              <div class="text-subtitle-1 font-weight-black mb-0 line-clamp-1">
                                {{ notaData.nombre_materia !== null ? notaData.nombre_materia : 'Materia sin nombre' }}
                              </div>
                              <div class="text-tiny grey--text font-weight-bold uppercase">{{ notaData.nombre_curso || 'Inscripción Regular' }}</div>
                           </div>
                        </div>

                        <div class="elite-grades-grid">
                           <div class="grade-slot pa-4 rounded-xl mb-3">
                              <div class="d-flex justify-space-between align-center">
                                 <span class="text-caption font-weight-bold grey--text">PRIMER PARCIAL</span>
                                 <v-chip small :color="getGradeColor(notaData.parcial1)" dark class="font-weight-black">
                                    {{ notaData.parcial1 !== null ? notaData.parcial1 : 'N/A' }}
                                 </v-chip>
                              </div>
                           </div>

                           <div class="grade-slot pa-4 rounded-xl mb-3">
                              <div class="d-flex justify-space-between align-center">
                                 <span class="text-caption font-weight-bold grey--text">SEGUNDO PARCIAL</span>
                                 <v-chip small :color="getGradeColor(notaData.parcial2)" dark class="font-weight-black">
                                    {{ notaData.parcial2 !== null ? notaData.parcial2 : 'N/A' }}
                                 </v-chip>
                              </div>
                           </div>

                           <div class="grade-slot pa-4 rounded-xl mb-3">
                              <div class="d-flex justify-space-between align-center">
                                 <span class="text-caption font-weight-bold grey--text">RECUPERATORIO</span>
                                 <v-chip small :color="getGradeColor(notaData.recuperatorio)" dark class="font-weight-black">
                                    {{ notaData.recuperatorio !== null ? notaData.recuperatorio : 'N/A' }}
                                 </v-chip>
                              </div>
                           </div>

                           <div class="grade-slot total pa-4 rounded-xl border-dashed">
                              <div class="d-flex justify-space-between align-center">
                                 <span class="text-subtitle-2 font-weight-black primary--text">ESTADO FINAL</span>
                                 <v-chip v-if="notaData.final" color="primary" class="font-weight-black px-4" dark>
                                    {{ notaData.final }}
                                 </v-chip>
                                 <span v-else class="text-caption font-weight-bold grey--text italic">Pendiente</span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </v-card>
               </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>
<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Nota",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    title: "Notas Materias",
    notas: [],
  }),

  mounted() {
    if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true){
      this.$router.push({
          name: "Home"
        });
    }
    this.$API
      .get({
        url: "examenes/notas"
      }).then((res) => {
        let dataFromBackend = res;
        let processedData = [];
// Recorremos cada curso
for (let curso in dataFromBackend) {
  dataFromBackend[curso].forEach((materia) => {
    // Extraemos la información que vamos a mostrar en la tabla
    processedData.push({
      nombre_curso: materia.nombre_curso,
      nombre_materia: materia.nombre_materia,
      parcial1: materia.parcial1,
      parcial2: materia.parcial2,
      recuperatorio: materia.recuperatorio,
      final: materia.estado_final, // Usamos estado_final como "Examen Final"
    });
  });
}

// Asignamos los datos procesados a la variable notas
this.notas = processedData;
      });
  },
  methods: {
    getGradeColor(grade) {
      if (grade === null || grade === '' || isNaN(grade)) return 'grey';
      let val = parseFloat(grade);
      if (val >= 7) return 'success';
      if (val >= 4) return 'info';
      return 'error';
    }
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@700;900&display=swap");

.prism-elite-app {
  font-family: "Inter", sans-serif !important;
  background: radial-gradient(circle at 100% 100%, #0f172a 0%, #1e293b 100%);
  min-height: 100vh;
}

h1, h2, h3, .prism-heading, .text-overline {
  font-family: "Outfit", sans-serif !important;
  letter-spacing: -0.5px;
}

.main-container-glass {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(20px);
  min-height: 90vh;
}

.prism-top-bar { background: transparent; }
.prism-divider { border-color: rgba(0,0,0,0.05) !important; }

/* Elite Cards */
.glass-card-interactive {
  background: white;
  border: 1px solid #f1f5f9 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05) !important;
}
.glass-card-interactive:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px -15px rgba(0, 0, 0, 0.1) !important;
  border-color: #e2e8f0 !important;
}

.elite-avatar-glow {
  box-shadow: 0 0 15px rgba(26, 35, 126, 0.15);
}

/* Grade Slots */
.grade-slot {
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  transition: background 0.3s;
}
.grade-slot:hover {
  background: #f1f5f9;
}
.grade-slot.total {
  background: #eff6ff;
  border-color: #dbeafe;
}

.border-dashed {
  border-style: dashed !important;
}

.text-tiny { font-size: 0.75rem !important; }
.uppercase { text-transform: uppercase; }
.line-clamp-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.h-full { height: 100%; }

.italic { font-style: italic; }

@media (min-width: 1264px) {
  .sticky-card {
    position: sticky;
    top: 20px;
  }
}
</style>